<template>
  <nav class="navbar min-w-1400">
    <div class="secondBox max-w-1400">
      <div class="logo">
        <!-- <img
          :src="require('@/page/betacreditdinero/components/img/logo.png')"
          :alt="logo"
          class="logoImg"
        /> -->
        <span class="title">FAPREI, S.A.P.I. DE C.V. SOFOM, E.N.R.</span>
      </div>
      <ul class="nav-links">
        <li :class="{ 'active-link': isActive('/') }" class="Li1">
          <router-link to="/" class="nav-link1">
            <span class="routeText1">Hogar</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/about' }" class="Li2">
          <router-link to="/about" class="nav-link2">
            <span class="routeText2">Misión y visión</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/introduce' }" class="Li3">
          <router-link to="/introduce" class="nav-link3">
            <span class="routeText3">Sobre nosotros</span>
          </router-link>
        </li>
        <li
          :class="{ 'active-link': $route.path === '/question' }"
          class="Li4"
        >
          <router-link to="/question" class="nav-link4">
            <span class="routeText4">Problema comun</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/protocol' }" class="Li5">
          <!-- <router-link to="/protocol" class="nav-link5">
            <span class="routeText5">Acuerdo de privacidad</span>
          </router-link> -->
          <a href="https://app.inbursasofomenrs.com/inbursa/PrivacyAgreementAndroid.html" class="nav-link3" target="_blank">
            <span class="routeText4">Acuerdo de privacidad</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- <div style="height: 130px"></div> -->
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #FFFFFF;
  height: 90px;
}

.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  /* height: 90px; */
  padding: 0 15px;
}

.logo {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoImg {
  width: 60px;
  height: 60px;
  margin-left: 30px;
}

.title {
  width: 460px;
  height: 24px;
  font-size: 16px;
  font-family: DM Sans-Bold;
  font-weight: 600;
  color: #333333;
  /* line-height: 23px; */
  padding-left: 17px;
  /* text-transform: uppercase; */
  line-height: 35px;
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 16px;
  font-family: SF Pro-Semibold;
  font-weight: 550;
  color: #666666;
  line-height: 29px;
  /* text-transform: uppercase; */
}



.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;

  margin: 0 auto;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  /* 水平居中对齐 */
}

.nav-links li {
  display: flex;
  padding: 6px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 39px;
  padding-left: 4px;
  padding-right: 4px;
}
.Li1 {
  width: 90px;
}
.Li2 {
  width: 150px;
}
.Li3 {
  width: 150px;
}
.Li4 {
  width: 170px;
  /* 这个如果给margin-right底部可能会出现边距的问题 */
}
.Li5 {
  width: 210px;
  /* 这个如果给margin-right底部可能会出现边距的问题 */
}
.active-link {
  border-color: #FF7936;
  background-color: #FF7936;
  border-radius: 10px;
}

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5 {
  font-family: Inter-Extra Bold;
  color: #ffffff;
}
.title{
  padding-left: 70px;
}
</style>